const NS = 'GamblingCalculator';
const CLS = 'gamblingCalculator';

function getModal(value) {
	let template = `
	<div id="videoModal" class="gamblingCalculator-modal modal hide fade d-block" tabindex="-1" role="dialog" aria-hidden="false">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true" class="icon icon--close"></span>
				</button>
				<div class="d-md-flex">
					<div class="gamblingCalculator-popup-icon">
						<img src="../../assets/images/gamblingCalculator/warning.svg" alt="warning icon">
					</div>
					<div class="flex-1">
						<div class="title mb-1">${value.title}</div>
						<div class="number mb-1">$10000 per year</div>
						<div class="desc mb-2">${value.desc}</div>
						<a href="${value.url}" class="btn btn-outline">${value.button}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
	`;

	return $(template);
}
export class GamblingCalculator {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$elPar = $(document.body);
		this.score = {
			title: 'title',
			button: 'title',
			desc: 'title',
			url: 'title',
		};
		this.$modal = getModal(this.score);

		console.log(this.$element.find('input[name=calculator-high-title]').val());
		this.highValue = {
			title: this.$element.find('input[name=calculator-high-title]').val(),
			desc: this.$element.find('input[name=calculator-high-description]').val(),
			button: this.$element.find('input[name=calculator-high-button]').val(),
			url: this.$element.find('input[name=calculator-high-url]').val(),
		};

		this.mediumValue = {
			title: this.$element.find('input[name=calculator-medium-title]').val(),
			desc: this.$element.find('input[name=calculator-medium-description]').val(),
			button: this.$element.find('input[name=calculator-medium-button]').val(),
			url: this.$element.find('input[name=calculator-medium-url]').val(),

		};

		this.lowValue = {
			title: this.$element.find('input[name=calculator-low-title]').val(),
			desc: this.$element.find('input[name=calculator-low-description]').val(),
			button: this.$element.find('input[name=calculator-low-button]').val(),
			url: this.$element.find('input[name=calculator-low-url]').val(),

		};

		console.log(this.score);
		this.init();
	}

	init() {
		this.$element.find('.gamblingCalculator-submit').on('click', () => {
			console.log('click');
			this.showModal();
			// disable link behaviour if inside a tag
			return false;
		});

		this.initInput();
	}

	calcuate() {
		let days = Number(this.$element.find('.input-wrapper input').first().val());
		console.log(days);
		this.score = this.mediumValue;
		if(days <= 10 ) {
			this.score = this.lowValue;
		}

		if(days > 20) {
			this.score = this.highValue;
		}

		this.$modal = getModal(this.score);
	}

	initInput() {
		this.$element.find('.input-wrapper input').each((i, e) => {
			console.log(i, e);
			$(e).on('change', (e) => {
				let value = $(e.currentTarget).val();
				console.log(value, $(e.currentTarget).parent().parent());
				if(value && value !== undefined && value !== null) {
					$(e.currentTarget).parent().parent()[0].dataset.value = value;
				} else {
					$(e.currentTarget).parent().parent()[0].dataset.value = null;
				}

				if($('.gamblingCalculator-item[data-value="null"]').length === 0) {
					$('.gamblingCalculator-submit').removeAttr('disabled');
					// do some calculation
					this.calcuate();
				} else {
					$('.gamblingCalculator-submit').prop('disabled', true);
				}
			});
		});
	}

	showModal() {
		// append to body incase not working inside the slick
		this.$elPar.append(this.$modal);
		// this.$el.append(this.$modal);
		$('#videoModal').modal();

		this.listenHideModal();
	}

	listenHideModal() {
		$('#videoModal').on('hide.bs.modal', () => {
			$('#videoModal').remove();
		});
	}
}
